import type { ReactNode } from 'react'

import { TEST_IDS } from '../../constants/testIds'
import type { CreateComponentsConfig } from '../../types'

interface ParagraphProps {
	readonly children: ReactNode
	readonly customProps?: CreateComponentsConfig['paragraphProps']
}

/** Renders a paragraph element with literal text content */
export const Paragraph = ({ children, customProps }: ParagraphProps) => (
	<p data-testid={TEST_IDS.PARAGRAPH} {...customProps}>
		{children}
	</p>
)
